import { render } from "./IconMenu.vue?vue&type=template&id=0701917e&scoped=true"
import script from "./IconMenu.vue?vue&type=script&lang=js"
export * from "./IconMenu.vue?vue&type=script&lang=js"

import "./IconMenu.vue?vue&type=style&index=0&id=0701917e&scoped=true&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0701917e"]])

export default __exports__